<template>
  <div class="status-table-cell">
    <div class="status">
      <span v-if="status === 'UNHEALTHY'">
          <i class="display-inline-block " :class="statusIcon"></i>
        <span class="display-inline-block capitalize-first-letter error">Error Connecting</span>
      </span>
      <span class="body1 display-inline-block" v-else>
        <i class="display-inline-block " :class="statusIcon"></i>
        <span class="display-inline-block capitalize-first-letter">{{ statusText }}</span>
      </span>
    </div>
    <div class="status" v-if="assetCount && !assetLink">
      <span class="body1 display-inline-block capitalize-first-letter"> {{ assetCount }} {{ assetText }} </span>
    </div>
    <div class="status capitalize-first-letter" v-if="assetCount && assetLink">
      <router-link
        class="display-block"
        :to="{
          name: assetLink.name,
          query: { type: accountType, accountKey: accountKey, nickName: nickName }
        }"
      >
        <a>{{ assetCount }} {{ assetText }}</a>
      </router-link>
    </div>
    <div class="progress" v-if="lastScanTime">
      <div class="body1">Synced {{ lastSynced }} ago</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import {formatFromNow} from '@/utilities/datetime.helper'
import {NANOSECONDS_TO_MILLISECONDS} from '@/constants/datetime.constants'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'IntegrationStatusTableCell',
  mixins: [loadDocumentationMixin],
  props: {
    status: {
      type: [String, Number]
    },
    assetCount: {
      type: [String, Number]
    },
    assetText: {
      type: [String, Number]
    },
    assetLink: {
      type: [String, Object]
    },
    lastScanTime: {
      type: [String, Number]
    },
    accountKey: {
      type: [String, Number]
    },
    accountType: {
      type: String
    },
    nickName: {
      type: String
    },
    source: {
      type: String
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  computed: {
    lastSynced() {
      if (this.lastScanTime && !moment(this.lastScanTime).isValid()) {
        return formatFromNow(this.lastScanTime * NANOSECONDS_TO_MILLISECONDS).split(' ')[0]
      }
      return formatFromNow(this.lastScanTime).split(' ')[0]
    },
    statusText() {
      switch (this.status) {
        case 'HEALTHY':
          return 'Connected'
        case 'UNHEALTHY':
          return 'Error Connecting'
        case 'INITIALIZING':
          return 'Initializing'
        case 'DISABLED':
          return 'Disabled'
        default:
          return ''
      }
    },
    statusIcon() {
      switch (this.status) {
        case 'HEALTHY':
          return 'far fa-check-circle'
        case 'UNHEALTHY':
          return 'fas fa-exclamation-triangle error'
        case 'INITIALIZING':
          return '"fad fa-spinner-third'
        case 'DISABLED':
          return 'far fa-times-circle'
        default:
          return ''
      }
    },
    docPath() {
      switch (this.source) {
        case 'GCP':
          return 'page-cloud-gcp'
        case 'AZURE':
          return 'page-cloud-azure'
        case 'AWS':
          return 'page-cloud-aws'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.error {
  font-size: 14px;
  color: var(--text-color-danger);
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/IntegrationStatusTableCell.vue